import axios from "axios";
import { GetLanguage, GetStorage, Logout } from "../credentialsService";
import { toast } from "@/utils/appToast";

export const backendCall = async ({
  url,
  method = "POST",
  data,
  isNavigate = true,
  isShowErrorMessage = true,
  contentType = "application/json",
  dataModel,
}: backendCall) => {
  const token = GetStorage()?.data?.token;

  const _headers = {
    "Content-Type": contentType,
    Accept: "*/*",
    Authorization: `Bearer ${token || ""}`,
  };

  try {
    const lang = GetLanguage() || "es";
    let langpara = url.includes("?") ? `&lang=${lang}` : `?lang=${lang}`;

    const response = await axios(
      import.meta.env.VITE_BACKEND_URL + url + langpara,
      {
        method,
        data,
        headers: _headers,
        withCredentials: true,
      }
    );

    let responseData = response.data;

    if (dataModel) {
      let dataSet = dataModel.adapt(responseData.data);
      responseData.data = dataSet;
    }

    return {
      success: true,
      data: responseData,
    };
  }  catch (error: any) {
  const status = error?.response?.status;
  const errorData = error?.response?.data || {};

  const isLoginApi =
    url.includes("login") ||
    url.includes("auth/login") ||
    url.includes("sign-in");

  // ✅ ONLY logout on 401
  if (status === 401 && !isLoginApi) {
    toast.error("Session expired. Please login again.");
    await Logout(false);
    window.location.href = "/";
  }

  // ✅ 403 = authorized but not allowed
  if (status === 403) {
    return {
      success: false,
      status,
      data: errorData,
      message: errorData.message || "You are not allowed to perform this action.",
    };
  }

  return {
    success: false,
    data: errorData,
    status,
    message: errorData.message || error.message || "Unknown error",
  };
}
};
